import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const MitgliedPage = lazy(() => import("../pages/mitglied/page"));
const UeberUnsPage = lazy(() => import("../pages/ueber-uns/page"));
const SchulungPage = lazy(() => import("../pages/schulung/page"));
const AktuellesPage = lazy(() => import("../pages/aktuelles/page"));
const KontaktPage = lazy(() => import("../pages/kontakt/page"));
const ImpressumPage = lazy(() => import("../pages/impressum/page"));
const DatenschutzPage = lazy(() => import("../pages/datenschutz/page"));
const SatzungPage = lazy(() => import("../pages/satzung/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/mitglied-werden",
    element: <MitgliedPage />,
  },
  {
    path: "/ueber-uns",
    element: <UeberUnsPage />,
  },
  {
    path: "/schulung",
    element: <SchulungPage />,
  },
  {
    path: "/aktuelles",
    element: <AktuellesPage />,
  },
  {
    path: "/kontakt",
    element: <KontaktPage />,
  },
  {
    path: "/impressum",
    element: <ImpressumPage />,
  },
  {
    path: "/datenschutz",
    element: <DatenschutzPage />,
  },
  {
    path: "/satzung",
    element: <SatzungPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
